import { isAuthenticated } from '@/auth/authGuard'
import { LazyLoadView } from '@/router/utils'

export default [
  {
    name: 'import',
    path: '/import/:type',
    props: true,
    component: () => LazyLoadView(import(/* webpackChunkName: "import" */ '@/views/Import/Component.vue')),
    beforeEnter: isAuthenticated,
  },
]
